module.exports = __webpack_public_path__ + "img/1539331598.78eab11e.jpg";